/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWorkflowRequest } from '../models/CreateWorkflowRequest';
import type { Page_WorkflowDto_ } from '../models/Page_WorkflowDto_';
import type { UpdateWorkflowRequest } from '../models/UpdateWorkflowRequest';
import type { WorkflowDto } from '../models/WorkflowDto';
import type { WorkflowSummaryLiteProjection } from '../models/WorkflowSummaryLiteProjection';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkflowControllerService {
  /**
   * filterWorkflows
   * @returns Page_WorkflowDto_ OK
   * @throws ApiError
   */
  public static filterWorkflowsUsingGet({
    limit = 10,
    offset,
    search,
  }: {
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_WorkflowDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workflows',
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createWorkflow
   * @returns WorkflowDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createWorkflowUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateWorkflowRequest;
  }): CancelablePromise<WorkflowDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/workflows',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateWorkflow
   * @returns WorkflowDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateWorkflowUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateWorkflowRequest;
  }): CancelablePromise<WorkflowDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/workflows',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getWorkflowsUnpaged
   * @returns WorkflowSummaryLiteProjection OK
   * @throws ApiError
   */
  public static getWorkflowsUnpagedUsingGet(): CancelablePromise<
    Array<WorkflowSummaryLiteProjection>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workflows/unpaged',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getWorkflow
   * @returns WorkflowDto OK
   * @throws ApiError
   */
  public static getWorkflowUsingGet({
    workflowId,
  }: {
    /**
     * workflowId
     */
    workflowId: string;
  }): CancelablePromise<WorkflowDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/workflows/{workflowId}',
      path: {
        workflowId: workflowId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteWorkflow
   * @returns any OK
   * @throws ApiError
   */
  public static deleteWorkflowUsingDelete({
    workflowId,
  }: {
    /**
     * workflowId
     */
    workflowId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/workflows/{workflowId}',
      path: {
        workflowId: workflowId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
